import { LEGO_LOCALES, resolveLegoLocale } from './legoLocale.mjs';
// Rakuten Advertising affiliate deeplinks for the LEGO EU program.
// Both env vars come from the Rakuten dashboard ("View available links" →
// any deeplink shows id= and mid=). While they are unset, every helper
// falls back to the plain LEGO.com URL, so links keep working untracked.
const RAKUTEN_ID = process.env.NEXT_PUBLIC_RAKUTEN_ID;
const RAKUTEN_LEGO_MID = process.env.NEXT_PUBLIC_RAKUTEN_LEGO_MID;

export const affiliateEnabled = Boolean(RAKUTEN_ID && RAKUTEN_LEGO_MID);

// Known lego.com shop locales. Without a locale in the URL, the Rakuten
// redirect lands on en-us regardless of where the visitor is, so we put the
// browser locale in the deeplink target when it maps to a real LEGO shop.
// Shared with server rendering so prices and catalog labels use one shop.
export function detectLegoLocale() {
  return resolveLegoLocale(typeof navigator === 'undefined' ? '' : navigator.language).toLowerCase();
}

// Client-only rough EU check via the device timezone. Good enough to decide
// whether showing a LEGO shop button makes sense (the EU program only pays
// out on European orders); not used for anything privacy-sensitive.
export function isEuVisitor() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    return tz.startsWith('Europe/')
      || ['Atlantic/Canary', 'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Reykjavik'].includes(tz);
  } catch {
    return false;
  }
}

export function legoAffiliateUrl(targetUrl) {
  if (!affiliateEnabled) return targetUrl;
  return `https://click.linksynergy.com/deeplink?id=${encodeURIComponent(RAKUTEN_ID)}&mid=${encodeURIComponent(RAKUTEN_LEGO_MID)}&murl=${encodeURIComponent(targetUrl)}`;
}

export function legoProductUrl(setId, locale) {
  const prefix = locale && LEGO_LOCALES.has(locale) ? `${locale}/` : '';
  return legoAffiliateUrl(`https://www.lego.com/${prefix}product/${setId}`);
}

// Affiliate links must be marked rel="sponsored" for search engines.
export const affiliateRel = affiliateEnabled ? 'sponsored noopener noreferrer' : 'noopener noreferrer';
